import { Stack } from '@mui/material';
import { StaticDateTimePicker } from '@mui/x-date-pickers';
import styled from 'styled-components';

export const FormDateTimePickerContainer = styled(Stack)`
  && {
    & .MuiDialogActions-root {
      display: none !important;
    }
  }
`;

export const StyledStaticDateTimePicker = styled(StaticDateTimePicker)`
  && {
    .MuiYearCalendar-button,
    .MuiPickersDay-root,
    .MuiMultiSectionDigitalClockSection-item {
      border-radius: ${({ theme }) => theme.shape.buttonRadius.small};
      ${({ theme }) => theme.typography.p8};
    }

    .MuiIconButton-root {
      border-radius: ${({ theme }) => theme.shape.buttonRadius.extraSmall};
    }

    .MuiPickersToolbar-title {
      ${({ theme }) => theme.typography.h7};
      color: ${({ theme }) => theme.palette.text.secondary};
      margin-bottom: 1rem;
    }

    .MuiYearCalendar-root {
      justify-content: space-between;
      column-gap: 0.75rem;

      & > button {
        width: 30%;
      }
    }
  }
`;
